import { useAuthStore } from '@/stores/auth';
import type { CaptionMode } from '../components/verification-upload-parts';

export type Lock = {
  photoLocked: boolean;
  igLocked: boolean;
  photoUrl: string | null;
  lockedIg: string;
  mode: CaptionMode;
};

function captionMode(p: boolean, i: boolean): CaptionMode {
  if (p && i) return 'both-locked';
  if (p) return 'photo-locked';
  if (i) return 'ig-locked';
  return 'both';
}

export function useVerificationLock(): Lock {
  const user = useAuthStore((s) => s.user);
  const photoLocked = !!user?.verification_photo;
  const igLocked = !!user?.ig_username;
  const photoUrl =
    user && user.verification_photo
      ? `/api/files/team_members/${user.id}/${user.verification_photo}`
      : null;
  return {
    photoLocked,
    igLocked,
    photoUrl,
    lockedIg: user?.ig_username ?? '',
    mode: captionMode(photoLocked, igLocked),
  };
}
